import { render } from "./ReachMe.vue?vue&type=template&id=2fa6e084&scoped=true"
import script from "./ReachMe.vue?vue&type=script&lang=js"
export * from "./ReachMe.vue?vue&type=script&lang=js"

import "./ReachMe.vue?vue&type=style&index=0&id=2fa6e084&lang=scss&scoped=true"

import exportComponent from "E:\\myProjects\\myPortfolio\\my-portfolio-vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa6e084"]])

export default __exports__